import React from 'react';
import { Box, Heading, Text } from '@chakra-ui/react';
import { useUser } from '../Context/UserContext';
import MasterDashboard from './Master/MasterDashboard';
import FinanceiroDashboard from './FinanceiroDashboard';
import AdministracaoDashboard from './AdministracaoDashboard';
import ComercialDashboard from './ComercialDashboard';
import MarketingDashboard from './MarketingDashboard';
import DesignDashboard from './DesignDashboard';
import TIDashboard from './TIDashboard';
import SuporteDashboard from './Suporte/SuporteDashboard';

const DashboardController = () => {
  const { user } = useUser();
  
  // Default message if no user or permissions
  if (!user || !user.permissions || user.permissions.length === 0) {
    return (
      <Box textAlign="center" p={10}>
        <Heading size="lg" mb={4}>Sem dashboard disponível</Heading>
        <Text>Você não possui permissões para visualizar um dashboard específico.</Text>
      </Box>
    );
  }

  // Simple permission to dashboard mapping
  if (user.permissions.includes('Master')) {
    return <MasterDashboard />;
  }
  
  if (user.permissions.includes('Financeiro')) {
    return <FinanceiroDashboard />;
  }
  
  if (user.permissions.includes('Administração')) {
    return <AdministracaoDashboard />;
  }
  
  if (user.permissions.includes('Comercial')) {
    return <ComercialDashboard />;
  }
  
  if (user.permissions.includes('Marketing')) {
    return <MarketingDashboard />;
  }
  
  if (user.permissions.includes('Design')) {
    return <DesignDashboard />;
  }
  
  if (user.permissions.includes('TI')) {
    return <TIDashboard />;
  }
  
  if (user.permissions.includes('Suporte')) {
    return <SuporteDashboard />;
  }
  
  // If no specific dashboard found for the user's permissions
  return (
    <Box textAlign="center" p={10}>
      <Heading size="lg" mb={4}>Sem dashboard específico</Heading>
      <Text>Seu cargo atual ({user.permissions.join(', ')}) não possui um dashboard específico configurado.</Text>
    </Box>
  );
};

export default DashboardController;